import axios from "@/util/basehttp";
import qs from "qs";

const pre = "/topic/base";

const topic = {
  topicListPage(
    pageSize,
    limit,
    keyWord,
    difficulty,
    topicType,
    classId,
    subjectId,
    sectionId,
    pointId,
    startTime,
    endTime
  ) {
    return axios.get(pre + `/topicListPage`, {
      params: {
        pageSize: pageSize,
        limit: limit,
        keyWord: keyWord,
        difficulty: difficulty,
        topicType: topicType,
        classId: classId,
        subjectId: subjectId,
        sectionId: sectionId,
        pointId: pointId,
        startTime: startTime,
        endTime: endTime
      }
    });
  },

  topicInfo(id) {
    return axios.get(pre + `/topicInfo`, { params: { id: id } });
  },
  topicSave(params, optionList) {
    return axios.post(
      pre + `/topicSave`,
      qs.stringify({
        data: params,
        optionList: optionList
      })
    );
  },
  topicDelete(id) {
    return axios.delete(pre + `/topicDelete`, { params: { id: id } });
  },
  updateTopicSort(params) {
    return axios.post(pre + `/updateTopicSort`, qs.stringify(params));
  },
  importExcel(formData, params) {
    return axios.post(pre + "/importExcel", formData, {
      params: params,
      "Content-Type": "multipart/form-data;charset=utf-8"
    });
  },
  importSectionExcel(formData) {
    return axios.post("/topic/section/importExcel", formData, {
      "Content-Type": "multipart/form-data;charset=utf-8"
    });
  },
  importPointExcel(formData) {
    return axios.post("/topic/point/importExcel", formData, {
      "Content-Type": "multipart/form-data;charset=utf-8"
    });
  },
  importWord(formData) {
    return axios.post(pre + "/importWord", formData, {
      "Content-Type": "multipart/form-data;charset=utf-8"
    });
  }
};
export default topic;



// WEBPACK FOOTER //
// ./src/api/topic/topic.js